// extracted by mini-css-extract-plugin
export default {"home_cate_head":"home_home_cate_head__Z2+MC","container":"home_container__vtvrJ"};